<template>
  <div>
    <base-header class="pb-1">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Cadastro de Cliente</h6>
        </div>
      </div>
    </base-header>
  
    <div class="container-fluid mt--6">
      <form class="needs-validation" @submit.prevent="salvarHolder">
        <card>
          <h3 slot="header" class="mb-0">Dados Básicos</h3>
          <div class="form-row">
            <div class="col-md-3">
              <template v-if="subscription.typeSub === 'PF'">
                <base-input label="CPF" name="cpf" placeholder="CPF" required v-model="holder.cpfCnpj"
                  :mask="'###.###.###-##'" @blur="handleCpfChange(holder.cpfCnpj, currentCpf)">
                </base-input>
              </template>
              <template v-else-if="subscription.typeSub === 'PJ'">
                <base-input label="CNPJ" name="cnpj" placeholder="CNPJ" required
                  :value="holder.cpfCnpj"
                  @input="onCnpjInput"
                  @blur="handleCpfChange(holder.cpfCnpj, currentCpf)">
                </base-input>
              </template>
            </div>
            <div class="col-md-6">
              <base-input :label="subscription.typeSub === 'PF' ? 'Nome Completo' : 'Razão Social'" name="nomecompleto"
                :placeholder="subscription.typeSub === 'PF' ? 'Nome Completo' : 'Razão Social'" required
                v-model="holder.name">
              </base-input>
            </div>
            <div class="col-md-3" v-if="subscription.typeSub === 'PF'">
              <base-input label="Data de Nascimento" name="datadenascimento" placeholder="Data de Nascimento"
                v-model="holder.dateOfBirth" :mask="'##/##/####'">
              </base-input>
            </div>
            <div class="col-md-3">
              <base-input label="E-mail" name="email" placeholder="E-mail" v-model="holder.email" type="email"
                :rules="{ required: true, email: true }">
              </base-input>
            </div>
            <div class="col-md-3">
              <base-input label="Tel Celular" name="celular" placeholder="Tel Celular" required v-model="holder.cellPhone"
                :mask="['(##)#####-####']">
              </base-input>
            </div>
            <div class="col-md-3">
              <base-input label="Tel Res/Com" name="homePhone" placeholder="Tel Res/Com" v-model="holder.homePhone"
                :mask="['(##)####-####','(##)#####-####']">
              </base-input>
            </div>
            <div class="col-md-3" v-if="subscription.typeSub === 'PF'">
              <base-input label="Sexo" required>
                <el-select v-model="holder.sex">
                  <el-option value="MALE" label="Masculino" />
                  <el-option value="FEMALE" label="Feminino" />
                  <el-option value="NI" label="Não informado" />
                </el-select>
              </base-input>
            </div>
          </div>
        </card>
  
        <div class="row">
          <!-- Endereco -->
          <div class="col-lg-12">
            <div class="card-wrapper">
              <card>
                <h3 slot="header" class="mb-0">Endereço</h3>
                <div class="row">
                  <div class="col-md-6">
                    <base-input append-icon="fas fa-map-marker" name="cep" label="CEP" placeholder="CEP" required
                      v-model="holder.zipcode" :mask="'########'" @blur="validateZipcode">
                    </base-input>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <base-input label="Endereço" name="endereco" placeholder="Endereço" required v-model="holder.address">
                    </base-input>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <base-input label="Número" name="numero" required placeholder="Número" v-model="holder.number">
                    </base-input>
                  </div>
                  <div class="col-md-8">
                    <base-input label="Complemento" name="complemento" placeholder="Complemento"
                      v-model="holder.complementAddress">
                    </base-input>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <base-input label="UF" name="uf" placeholder="UF" required v-model="holder.uf">
                    </base-input>
                  </div>
                  <div class="col-md-8">
                    <base-input label="Cidade" name="cidade" placeholder="Cidade" required v-model="holder.city">
                    </base-input>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <base-input label="Bairro" name="bairro" placeholder="Bairro" required v-model="holder.neighborhood">
                    </base-input>
                  </div>
                </div>
              </card>
            </div>
          </div>
        </div>
  
        <div class="col-md-12 text-center mb-3">
          <base-button type="primary" native-type="submit" :disabled="beginSaveProcess">Salvar Cliente</base-button>
        </div>
  
      </form>
    </div> <!--- fecha conteudo -->
    <!-- Modal ineligible -->
    <customer-ineligible-modal :show="ineligible.show" :cpf="ineligible.cpf" :subscriptions="ineligible.subscriptions"
      @close="ineligible.show = false" />
  
  </div>
</template>
<script>
import { Select, Option } from 'element-ui';
import { ModalCustomerIneligible } from '../components/NovaAssinatura/Shared';
import { applyCnpjMask } from '@/util/cnpj'

export default {
  props: ['holderId', 'subscriptionId'],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [ModalCustomerIneligible.name]: ModalCustomerIneligible,
  },
  created() {
    this.loadHolder();
    this.loadSubscription();
  },
  data() {
    return {
      beginSaveProcess: false,
      currentCpf: '',
      holder: {
        id: null,
        cpfCnpj: '',
        name: '',
        dateOfBirth: '',
        sex: 'MALE',
        email: '',
        cellPhone: '',
        homePhone: '',
        zipcode: '',
        address: '',
        complementAddress: '',
        uf: '',
        city: '',
        neighborhood: '',
        isHolder: true
      },
      subscription: {
        typeSub: '',
        pets: [],
        plan: {
          name: ''
        },
        holder: {
          name: '',
          id: 0
        }
      },
      ineligible: {
        show: false,
        cpf: "",
        subscriptions: [],
      }
    };
  },
  methods: {
    onCnpjInput(value) {
      this.holder.cpfCnpj = applyCnpjMask(value)
    },
    salvarHolder() {
      try {
        this.$validator.validateAll();
      } finally {
        this.validated = true;
      }
      if (this.validated) {
        this.beginSaveProcess = true
        this.$clubApi.post('/holder', this.holder)
          .then(() => {
            this.$notify({ type: 'success', message: "Dados salvos com sucesso." })
            if (this.subscriptionId != null) {
              location.href = '/assinatura/' + this.subscriptionId;
            }
          })
          .catch((error) => this.$notify({ type: 'warning', message: error.response.data.msg }))
          .finally(() => {
            this.beginSaveProcess = false
            NProgress.done()
          })
      }
    },
    loadSubscription() {
      return this.$clubApi.get('/subscription/' + this.subscriptionId)
        .then((response) => {
          this.subscription = response.data.object;
        })
        .catch((error) => this.$notify({ type: 'warning', message: error.response.data.msg }))
        .finally(() => NProgress.done());
    },
    loadHolder() {
      this.$clubApi.get('/holder/' + this.holderId)
        .then((response) => {
          this.holder = response.data.object
          this.holder.cpfCnpj = this.holder.cpfCnpjFmt;
          this.holder.isHolder = true;
          this.currentCpf = this.holder.cpfCnpj;
        })
        .catch(() => this.$notify({ type: 'warning', message: 'Erro ao carregar dados do cliente.' }))
        .finally(() => NProgress.done());
    },
    validateZipcode() {
      var zipcode = this.holder.zipcode.replace("-", "");
      this.$clubApi.get('/utils/zipcode/' + zipcode)
        .then((response) => {
          this.holder.address = response.data.object.logradouro;
          this.holder.uf = response.data.object.uf;
          this.holder.city = response.data.object.localidade;
          this.holder.neighborhood = response.data.object.bairro;
        })
        .catch(() => {
          this.$notify({
            type: 'warning',
            message: 'Não foi possível buscar o endereço pelo CEP. Por favor, preencha manualmente.'
          })
        })
        .finally(() => NProgress.done());
    },
    handleCpfChange(cpf, currentCpf = undefined) {
      if (this.subscription.typeSub === 'PJ' || cpf === currentCpf) {
        return;
      }

      if (cpf && this.subscription.plan && this.subscription.plan.newCustomersOnly) {
        this.checkEligibility(cpf);
      }
    },
    checkEligibility(cpf) {
      const formattedCpf = cpf.replace(/\D/g, '');
      this.$clubApi.get(`/eligibility/${formattedCpf}/cpf`)
        .then(response => {
          const eligibilityData = response.data.object;

          if (!eligibilityData.eligible) {
            delete eligibilityData.subscriptions[this.subscription.id];
          }

          const remainingSubscriptions = Object.keys(eligibilityData.subscriptions);

          if (!eligibilityData.eligible && remainingSubscriptions.length > 0) {
            this.showIneligiblePopup(cpf, eligibilityData.subscriptions);
          }
        })
        .catch(() => this.$notify({
          type: 'warning',
          message: 'Erro ao verificar elegibilidade do CPF'
        }))
        .finally(() => NProgress.done());
    },
    showIneligiblePopup(cpf, subscriptions) {
      this.ineligible.cpf = cpf;
      this.ineligible.subscriptions = subscriptions;
      this.ineligible.show = true;
    }
  }
};
</script>
<style></style>
